import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  LuSmartphone,
  LuQrCode,
  LuSend,
  LuMail,
  LuPhone,
} from "react-icons/lu";
import VerificationMethodBox from "./VerificationMethodBox";
import { maskEmail } from "Utils/Utils";
const TwoFactorAuthPage = () => {
  // get the data from the state of route
  const location = useLocation();
  const state = location.state || {};
  const searchParams = new URLSearchParams(location.search);
  const patientId = searchParams.get("patientId");
  const visitId = searchParams.get("visitId");
  const navigate = useNavigate();

  const handleSendCode = async (method) => {
    try {
      if (visitId) {
        return navigate(`/verify-otp/?visitId=${visitId}`, {
          state: {
            transferVia: method,
            token: state.token,
            encryptPassword: state.encryptPassword,
            email: state.email,
          },
        });
      } else if (patientId) {
        return navigate(`/verify-otp/?patientId=${patientId}`, {
          state: {
            transferVia: method,
            token: state.token,
            encryptPassword: state.encryptPassword,
            email: state.email,
          },
        });
      }
      return navigate("/verify-otp", {
        state: {
          transferVia: method,
          token: state.token,
          encryptPassword: state.encryptPassword,
          email: state.email,
        },
      });

      // Here you would navigate to OTP verification page
    } catch (error) {
    }
  };

  const navigateToLogin = () => {
    navigate("/login");
  };
  return (
    <div className="flex items-center justify-center min-h-screen p-4 bg_gradient ">
      <div className="flex flex-col gap-4">
        <h1 className="text-3xl font-semibold text-center ">
          Two-Step Verification
        </h1>
        <p className="mb-5 font-semibold text-md ">
          Choose how you would like to receive your verification code
        </p>
        {state.twoFactorViaAuthenticator && (
          <VerificationMethodBox
            mainIcon={<LuSmartphone size={28} />}
            btnIcon={<LuQrCode size={16} />}
            btnLabel="Enter Code"
            headeing="Google Authenticator"
            subHeading="Use authenticator app"
            onClick={() => handleSendCode("authenticator")}
          />
        )}

        {state.twoFactorViaText && (
          <VerificationMethodBox
            mainIcon={<LuPhone size={28} />}
            btnIcon={<LuSend size={16} />}
            btnLabel="Send Code"
            headeing="Phone Verification"
            subHeading="XXX-XXX-3493"
            onClick={() => handleSendCode("text")}
          />
        )}

        {state.twoFactorViaEmail && (
          <VerificationMethodBox
            mainIcon={<LuMail size={28} />}
            btnIcon={<LuSend size={16} />}
            btnLabel="Send Code"
            headeing="Email Verification"
            subHeading={maskEmail(state.email)}
            onClick={() => handleSendCode("email")}
          />
        )}
        <span
          onClick={navigateToLogin}
          className="text-sm text-right text-gray-500 cursor-pointer hover:underline"
        >
          {" "}
          Back to Login{" "}
        </span>
      </div>
    </div>
  );
};

export default TwoFactorAuthPage;
